import React from 'react';
import PropTypes from 'prop-types';

import CCSSearch from '@ey/canvascoreservices/Search';

const Search = ({...rest}) => <CCSSearch {...rest} />;

Search.propTypes = {};

export default Search;
